$(document).ready(function(){

  $('.featured_block_details,.product_grid_item').click(function(){
    var url = $(this).find('a').attr('href');
    window.location.href = url;
  });
  

  $( "#customer_login" ).submit(function( event ) {
    //ent.preventDefault();
    var lemail = $("#CustomerEmail").val();
    var pass	= $("#CustomerPassword");
    var flag=false;
    if(lemail != '')
    {
      if(!isValidEmailAddress(lemail))
      {
        $(".val_error").html("<span>Email Id not valid</span>");
        flag=false;
      }
    } else {
      $(".val_error").html("<span>Email Id required</span>");
    	flag=true;
    }

     if(pass.val().length==0){
      	$(".error_pass").html("<span> Password is required</span>");
		flag=false;
    }
    else {
     
    	flag=true;
    }

   
   if(flag==true)
     return true;
    else
      return false;
  });


  /*---------------------- Subscribe Validation------------------------- */
  $( "#contact_form" ).submit(function( event ) {
   //vent.preventDefault();
    var subemail = $("#Email").val();
    var flag= false;

    if(subemail != '')
    {
      if(!isValidEmailAddress(subemail))
      {
        $(".val_error_sub").html("<span>Email Id not valid</span>");
         flag=false;
      }
    } else {
      $(".val_error_sub").html("<span>Email Id required</span>");
       flag=true;
    }
   
    
		 if(flag==true)
      $( "#contact_form").submit();

  });
  
  /*----------------- Signup Validation-------------------------------------*/
  $( "#create_customer" ).submit(function( event ) {
   // ent.preventDefault();
    var fname = $("#FirstName");
    var lname = $("#LastName");
    var cemail = $("#Email").val();
    var cpassword = $("#CreatePassword");
	var count = 0;
    if(fname.val().length==0){
      $(".error_fname").html("<span>First Name required</span>");
		count++;
    }	
    else{
      $(".error_fname").html("");
      
    }

    if(cemail != '')
    {
      if(!isValidEmailAddress(cemail))
      {
       
        $(".val_error_reg").html("<span>Email Id not valid</span>");
        count++;	 
        return false;
      	
      }
    } 
    else 
    {
    	$(".val_error_reg").html("<span>Email Id required</span>");
      	
    }


    if(lname.val().length==0){
      	$(".error_lname").html("<span>Last Name required</span>");
	  	count++;
    }
    else
    {
      $(".error_lname").html("");
	  	
    }
    
    if(cpassword.val().length==0){
      	$(".error_cpassword").html("<span> Password is required</span>");
		count++;
    }
    
     
    
    if(count<1){
    
      $( "#create_customer" ).submit();
    }

  });



});



function isValidEmailAddress(value){
  var re =  /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;
  console.log(re.test(value));
  return re.test(value);
}
/*------------------Social Icons toogle------------------*/

$(document).ready(function(){
    $(".social_text").click(function(){
        $(".facebook_share").slideToggle("slow");
    });
  $('.site-footer__linklist-item a').click(function(){
    $('body').find('.fancybox-close-small').click();
  });
});